import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToHash()
    document.addEventListener("turbo:load", () => this.scrollToHash())
  }

  scrollToHash() {
    const { hash } = window.location
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) el.scrollIntoView({ behavior: "auto" })
    }
  }
}
